import { setActivePaginationPage } from "@global-state/pages/admin/promoCodes/slice";
import { useGetAllPromoCodesQuery } from "@RTKQuery/admin/promoCodes/promoCodes";
import { Pagination } from "@ui";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "store/hooks";

export function PaginationContainer() {
    const [queryParams, setQueryParams] = useSearchParams();

    const activePaginationPage = useAppSelector(state => state.promoCodesAdminPage.activePaginationPage);

    const { data } = useGetAllPromoCodesQuery({
        page: activePaginationPage
    });

    const dispatch = useAppDispatch();
    useEffect(() => {
        if (!queryParams.get("page")) {
            setQueryParams((params) => {
                return {
                    ...Object.fromEntries(params),
                    page: String(activePaginationPage),
                }
            }, {
                replace: true,
            })
        }
    }, []);

    if (data?.count_items) {
        return (
            <div className="w-fit mx-auto mb-[20px]">
                <Pagination
                    activePage={activePaginationPage - 1}
                    count={Math.ceil((data?.count_items || 0) / 50)}
                    onClickPage={(page) => {
                        setQueryParams((params) => ({
                            ...Object.fromEntries(params),
                            page: String(page + 1),
                        }));
                        dispatch(setActivePaginationPage(page + 1))
                    }}
                />
            </div>
        )
    } else {
        return null;
    }
}